import { API_BASE_URL, ApiPath, Global } from '@manage-cards/constants';
import {
	attachAuthToken,
	attachBrowserFingerprint,
} from '@manage-cards/services/interceptors';
import {
	ICardListResponse,
	IUserSummaryDetails,
	IUserSummaryPayload,
} from '@manage-cards/types';

import { ApiDpopClient } from '@shared/services';

class ApiClient {
	private readonly apiClient: ApiDpopClient;
	constructor() {
		this.apiClient = new ApiDpopClient({
			withCredentials: false,
			baseURL: API_BASE_URL,
			timeout: 10000,
			headers: Global.BASE_HEADERS,
			// refreshToken: this.refreshTestModeToken,
			refreshStatusCodes: [412],
		});

		this.apiClient.addRequestInterceptors(attachAuthToken);
		this.apiClient.addRequestInterceptors(attachBrowserFingerprint);
	}

	getUserSummary = (data: IUserSummaryPayload): Promise<IUserSummaryDetails> =>
		this.apiClient.post(ApiPath.USER_SUMMARY, { data });

	getUserCards = (): Promise<ICardListResponse> =>
		this.apiClient.get(ApiPath.USER_CARDS);

	deleteUserCard = (cardId: string, merchantId: string) =>
		this.apiClient.delete(
			ApiPath.DELETE_USER_CARD.replace('{CARD_ID}', cardId).replace(
				'{MERCHANT_ID}',
				merchantId,
			),
		);
}

const Api = new ApiClient();

export default Api;
